import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import { getPublicUrl } from "../../../../helpers/helper_functions";
import { InfoImage } from "./SharedComponents";

import "./InfoBox.css";

const ProSportsInfo = () => {
  return (
    <div className="info-box-wrapper right-box">
      <p className="info-text-title">Plant-based power</p>
      <div className="info-text-body" id="plantbasedpower">
        <p>
          {" "}
          There's a common misconception that going vegan means compromising on
          muscle mass and athletic fitness, but that's just plain wrong.
        </p>
        <p>
          Kyrie Irving, Chris Paul, Venus Williams, Alex Morgan, Carl Lewis,
          Lewis Hamilton, and one of the world's strongest men -- Patrik
          Boboumian -- are all 100% vegan! There are also plenty of plant-based
          Olympic gold-medalists and power atheletes that kick this myth into
          the dumpster, including superstars Cam Newton and Novak Djokovic. If
          you're interested, check out the documentary{" "}
          <a href="https://gamechangersmovie.com/">Game Changers</a> for more
          information.
        </p>
      </div>
    </div>
  );
};

const ProSportsImage = () => {
  return (
    <InfoImage
      className="info-box-image"
      $background_image={getPublicUrl("assets/Home/kyrieirving.jpg")}
      $background_image_details={"no-repeat 40% 40%"}
    ></InfoImage>
  );
};

export default {
  info: () => <ProSportsInfo />,
  image: () => <ProSportsImage />,
};
